<div class="back-button">
  <span class="copy-s btn btn-plain" (click)="backButton.emit()">
    <span class="mb-icon mb-icon-step-back"></span>
    @if (title) {
      <span [innerHTML]="title"></span>
    }
  </span>
</div>
@if (bypassedEmbedHTML) {
  <mb-consent-overlay [providerConfig]="consentProviderConfig" [backgroundImageUrl]="backgroundImageUrl">
    <ng-template>
      <div class="embed-wrapper" [innerHTML]="bypassedEmbedHTML"></div>
    </ng-template>
  </mb-consent-overlay>
}
